import React from "react";

import { ContactPersonPhoneCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function contactPersonPhone({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ContactPersonPhone,
		(item) => <Content item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default contactPersonPhone;
